import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { InstallBannerComponent } from './shared/install-banner.component';
import { UpdateBannerComponent } from './shared/update-banner.component';
import { ChatBubbleComponent } from './features/chat/chat-bubble.component';
import { PwaInstallService } from './core/pwa-install.service';
import { PwaUpdateService } from './core/pwa-update.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, InstallBannerComponent, UpdateBannerComponent, ChatBubbleComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('web');
  // Instantiate the PWA services at startup so their listeners/effects begin immediately.
  private readonly install = inject(PwaInstallService);
  private readonly update = inject(PwaUpdateService);
}
